var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomPage',{attrs:{"header-style":_vm.$ui.LAYOUT_HEADER_STYLE_WHITE}},[_c('StoryblokStoryWrapper',{attrs:{"path":_vm.categoriesStoryPath},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var blok = ref.blok;
return [(blok)?_c('BlokPage',{attrs:{"blok":blok}}):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }